<template>
	<section class="section-container">
		<div class="content-wrapper">
			<contentheading
					:button="$t('tenders.add-new')"
					:title="$t('tenders.title')"
					url="tender_add"/>
			<div class="row">
				<div class="col-xl-12">
					<div id="accordion">
						<div class="card mb-1">
							<div class="card-header" id="headingOne">
								<h4 class="mb-0">
									{{ $t('tenders.filter') }}
									<a
											class="text-inherit"
											data-toggle="collapse"
											data-target="#collapseOne"
											aria-expanded="true"
											aria-controls="collapseOne"
											href="">
										<i class="icon-arrow-down"></i>
									</a>
								</h4>
							</div>
							<div class="collapse hide" id="collapseOne" aria-labelledby="headingOne"
								 data-parent="#accordion">
								<div class="card-body border-top">
									<div class="row">
										<div class="col-12">
											<div  v-if="warehouse_groups.length > 1" class="form-row align-items-center">
												<div class="col-auto">
													<p class="form-control-plaintext mb-2">{{ $t('tenders.group') }}</p>
												</div>
												<div :key="group.name" class="col-auto"
													 v-for="group in warehouse_groups">
													<div class="form-check mb-2">
														<input
																class="form-check-input"
																:id="group.name"
																:name="group.name"
																type="checkbox"
																:value="group.id"
																v-model="filter_groups">
														<label class="form-check-label" :for="group.name">
                              {{ group.name	}}
                            </label>
													</div>
												</div>
											</div>

										</div>
									</div>
									<div class="row">
										<div class="col-12">
											<div class="form-row align-items-center">
												<div class="col-auto">
													<label class="sr-only" for="filter_start">{{
														$t('tenders.tender-start') }}</label>
													<datetime
															:phrases="{ok: 'Continue', cancel: 'Exit'}"
															:week-start="1"
															auto
															format="dd.MM.yyyy"
															id="filter_start"
															input-class="form-control mb-3"
															:placeholder="$t('tenders.tender-start')"
															type="date"
															value-zone="local"
															v-model="filter_start"
													></datetime>
												</div>
												<div class="col-auto">
													<label class="sr-only" for="filter_finish">{{
														$t('tenders.tender-finish') }}</label>
													<datetime
															:phrases="{ok: 'Continue', cancel: 'Exit'}"
															:week-start="1"
															auto
															format="dd.MM.yyyy"
															id="filter_finish"
															input-class="form-control mb-3"
															:placeholder="$t('tenders.tender-finish')"
															type="date"
															value-zone="local"
															v-model="filter_finish"
													></datetime>
												</div>
												<div class="col-auto">
													<label class="sr-only" for="filter_status">{{ $t('tenders.status') }}</label>
													<select class="chosen-select form-control mb-3" id="filter_status" v-model="filter_status">
														<option value="">--{{ $t('tenders.all-statuses') }}--</option>
														<option value="DRAFT">{{ $t('tenders.state.draft') }}</option>
														<option value="ACTIVE">{{ $t('tenders.state.active') }}</option>
														<option value="WAITING">{{ $t('tenders.state.waiting') }}</option>
														<option value="FINISHED">{{ $t('tenders.state.finished') }}</option>
														<option value="CHOOSING">{{ $t('tenders.state.choosing') }}</option>
														<option value="ORDERED">{{ $t('tenders.state.ordered') }}</option>
														<option value="CANCELED">{{ $t('tenders.state.canceled') }}</option>
														<option value="FAILED">{{ $t('tenders.state.failed') }}</option>
													</select>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-12">
											<div class="form-row align-items-center">
												<datefilters ref="datefilters"/>
											</div>
										</div>
									</div>
                  <div
                    v-if="!is_supplier"
                    class="row my-2"
                  >
                    <div class="col-auto">
                      <label for="failed_bc_details">Business Central</label>
                      <select class="chosen-select form-control mb-3" id="failed_bc_details" v-model="failed_bc_details">
                        <option value="">--{{ $t('tenders.all-statuses') }}--</option>
                        <option value="false">{{ $t('tenders.bc_synced_status.synced') }}</option>
                        <option value="true">{{ $t('tenders.bc_synced_status.error') }}</option>
                      </select>
                    </div>
                  </div>
									<div class="row">
										<div class="col-12">
											<div class="form-row align-items-center">
												<div class="col-auto">
													<button class="btn btn-success mb-2" type="submit" @click="filter">
														{{ $t('tenders.search') }}
													</button>
													<button class="btn btn-outline-info mb-2" type="cancel"
														@click="clear_filters"
                          >{{ $t('tenders.reset') }}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-xl-12">
					<div class="card">
						<div class="card-body">
							<div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
								<datatablebuttons v-if="!is_supplier"/>
								<search @make_search="make_search"/>
								<div class="table-responsive">
									<table class="table table-striped dataTable my-4 w-100" id="tenders">
										<thead>
										<tr>
											<th v-if="!is_supplier">
												<div class="checkbox c-checkbox">
													<label class="mb-0 p">
														<input class="select-box" type="checkbox" v-model="selectAll">
														<span class="fa fa-check"></span>
													</label>
												</div>
											</th>
											<th
													:class="{
                              'sorting_asc': ordering === 'code',
                              'sorting_desc': ordering === '-code'}"
													@click="order('code')">{{ $t('tenders.id') }}
											</th>
											<th
													:class="{
                              'sorting_asc': ordering === 'start',
                              'sorting_desc': ordering === '-start'}"
													@click="order('start')">{{ $t('tenders.start') }}
											</th>
											<th
													:class="{
                              'sorting_asc': ordering === 'finish',
                              'sorting_desc': ordering === '-finish'}"
													@click="order('finish')">{{ $t('tenders.finish') }}
											</th>
											<th
													:class="{
                              'sorting_asc': ordering === 'details_count',
                              'sorting_desc': ordering === '-details_count'}"
													@click="order('details_count')">{{ $t('tenders.parts-qty') }}
											</th>
											<th
													:class="{
                              'sorting_asc': ordering === 'proposals_count',
                              'sorting_desc': ordering === '-proposals_count'}"
													@click="order('proposals_count')">{{ $t('tenders.proposals') }}
											</th>
											<th
													:class="{
                              'sorting_asc': ordering === 'winners_count',
                              'sorting_desc': ordering === '-winners_count'}"
													@click="order('winners_count')">{{ $t('tenders.winners') }}
											</th>
											<th
													:class="{
                              'sorting_asc': ordering === 'creator__name',
                              'sorting_desc': ordering === '-creator__name'}"
													@click="order('creator__name')">{{ $t('tenders.creator') }}
											</th>
											<th
													:class="{
                              'sorting_asc': ordering === 'created',
                              'sorting_desc': ordering === '-created'}"
													@click="order('created')">{{ $t('tenders.created') }} / <span
													class="text-muted font-italic">{{ $t('tenders.updated') }}</span>
											</th>
											<th
													:class="{
                              'sorting_asc': ordering === 'approver__name',
                              'sorting_desc': ordering === '-approver__name'}"
													@click="order('approver__name')">{{ $t('tenders.approver') }}
											</th>
                      <th
                          v-if="is_supplier"
                          :class="{
                              'sorting_asc': ordering === 'proposal_created',
                              'sorting_desc': ordering === '-proposal_created'}"
                          @click="order('proposal_created')">{{ $t('tenders.proposal-created') }} / <span
                          class="text-muted font-italic">{{ $t('tenders.proposal-updated') }}</span>
                      </th>
											<th
													:class="{
                              'sorting_asc': ordering === 'group__name',
                              'sorting_desc': ordering === '-group__name'}"
													@click="order('group__name')">{{ $t('tenders.group') }}
											</th>
											<th
													:class="{
                              'sorting_asc': ordering === 'warehouse__name',
                              'sorting_desc': ordering === '-warehouse__name'}"
													@click="order('warehouse__name')">{{ $t('tenders.warehouse') }}
											</th>
											<th
													:class="{
                              'sorting_asc': ordering === 'status',
                              'sorting_desc': ordering === 'status'}"
													@click="order('status')">{{ $t('tenders.status') }}
											</th>
                      <th v-if="!is_supplier">BC</th>
											<th class="wd-xs"></th>
										</tr>
										</thead>
										<tbody>
										<tr :key="row.id" class="gradeX" v-for="(row, index) in rows">
											<td v-if="!is_supplier">
												<div class="checkbox c-checkbox">
													<label class="mb-0">
														<input :value="row.id" class="select-box" type="checkbox"
															   v-model="selected">
														<span class="fa fa-check"></span>
													</label>
												</div>
											</td>
											<td>
												<router-link
														v-if="row.status==='DRAFT'"
														:to="{name: 'tender_edit', params: {id: row.id}}"
														:title="$t('tenders.view')">
													{{ row.tender_code }}
												</router-link>
												<router-link
														v-else
														:to="{name: 'tender_view', params: {id: row.id}}"
														:title="$t('tenders.view')">
													{{ row.tender_code }}
												</router-link>
											</td>
											<td>{{ row.start | formatDateTime }}</td>
											<td>{{ row.finish | formatDateTime }}</td>
											<td>{{ row.details_count }}</td>
											<td>{{ row.proposals_count }}</td>
											<td>{{ row.winners_count }}</td>
											<td>{{ row.creator_name }}</td>
											<td>
												{{ row.created | formatDateTime }}
												<span
														v-if="format_date_time(row.created) !== format_date_time(row.updated)"
														class="text-muted font-italic small"><br>{{ row.updated | formatDateTime }}
                            </span>
											</td>
											<td>{{ row.approver_name }}</td>
                      <td v-if="is_supplier">
                        <span v-if="row.proposal_created">
                          {{ row.proposal_created | formatDateTime }}
                        </span>
                        <span
                            v-if="row.proposal_created && format_date_time(row.proposal_created) !== format_date_time(row.proposal_updated)"
                            class="text-muted font-italic small"><br>{{ row.proposal_updated | formatDateTime }}
                        </span>
                        <span v-if="!row.proposal_created && row.watched_date">
                          {{ row.watched_date | formatDateTime }}
                        </span>
                      </td>
											<td>{{ row.group_name }}</td>
											<td>{{ row.warehouse_name }}</td>
											<td>
                        <span class="rounded badge bg-warning-light px-4 ml-2 text-sm d-lg-inline" v-if="row.status === 'DRAFT'">
                          <span class="text-white">{{ $t('tenders.state.draft') }}</span>
                        </span>
												<span class="rounded badge bg-success-light px-4 ml-2 text-sm d-lg-inline" v-if="row.status === 'ACTIVE'">
                          <span class="text-white">{{ $t('tenders.state.active') }}</span>
                        </span>
												<span class="rounded badge bg-warning-light px-4 ml-2 text-sm d-lg-inline" v-if="row.status === 'WAITING'">
                          <span class="text-white">{{ $t('tenders.state.waiting') }}</span>
                        </span>
												<span class="rounded badge bg-warning-light px-4 ml-2 text-sm d-lg-inline" v-if="row.status === 'FINISHED'">
                          <span class="text-white">{{ $t('tenders.state.finished') }}</span>
                        </span>
												<span class="rounded badge bg-warning-dark px-4 ml-2 text-sm d-lg-inline" v-if="row.status === 'CHOOSING'">
                          <span class="text-white">{{ $t('tenders.state.choosing') }}</span>
                        </span>
												<span class="rounded badge bg-info-light px-4 ml-2 text-sm d-lg-inline" v-if="row.status === 'ORDERED'">
                          <span class="text-white">{{ $t('tenders.state.ordered') }}</span>
                        </span>
												<span class="rounded badge bg-danger-dark px-4 ml-2 text-sm d-lg-inline" v-if="row.status === 'CANCELED'">
                          <span class="text-white">{{ $t('tenders.state.canceled') }}</span>
                        </span>
												<span class="rounded badge bg-danger-light px-4 ml-2 text-sm d-lg-inline" v-if="row.status === 'FAILED'">
                          <span class="text-white">{{ $t('tenders.state.failed') }}</span>
                        </span>
											</td>

                      <td
                        v-if="!is_supplier"
                        class="text-center"
                      >
                        <b-c-tender-status :tender="row"/>
                      </td>

											<td>
												<div class="btn-group">
													<button
															v-if="row.status==='ORDERED' && ((is_supplier && row.is_winner) || !is_supplier)"
															class="btn btn-link p-0 mr-2 text-info"
															:title="$t('tenders.save-xls')"
															@click="exportExcel(row.id)">
														<i class="fas fa-file-excel"></i>
													</button>
													<button
															v-if="row.status==='ORDERED' && ((is_supplier && row.is_winner) || !is_supplier)"
															class="btn btn-link p-0 mr-1 text-info"
															:title="$t('tenders.save-pdf')"
															@click="exportPDF(row.id)">
														<i class="fas fa-file-pdf"></i>
													</button>
													<button
															v-if="row.status==='DRAFT' && parseInt(row.details_count) === 0"
															class="btn btn-link pl-1 pt-1 text-info"
															:title="$t('tenders.button-delete')"
															@click="remove_tender(row.id, index)">
														<i class="far fa-trash-alt"></i>
													</button>

													<div v-if="is_supplier">
														<button
																v-if="!row.watched"
																class="btn btn-link pl-1 pt-1 text-info"
																:title="$t('tenders.add-watched')"
																@click="add_watched(row.id, index)">
															<i class="far fa-eye text-success"></i>
														</button>
														<button
																v-if="row.watched"
																class="btn btn-link pl-1 pt-1 text-info"
																:title="$t('tenders.remove-watched')"
																@click="remove_watched(row.id, index)">
															<i class="far fa-eye-slash text-gray-dark"></i>
														</button>
													</div>

												</div>
											</td>
										</tr>
										</tbody>
									</table>
								</div>
								<pagination
										:page="page"
										:pages="pages"
										:count="count"
										:from="(page - 1) * page_size + 1"
										:to="(page - 1) * page_size + rows.length"
										@paginate="paginate"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import api from '@/api'
	import * as download from 'downloadjs'
	import Contentheading from '@/components/Contentheading.vue'
	import Datatablebuttons from '@/components/Datatablebuttons.vue'
	import Datefilters from '@/components/Datefilters'
	import {Datetime} from 'vue-datetime'
	import message from '@/message'
	import moment from 'moment'
	import Pagination from '@/components/Pagination.vue'
	import Search from '@/components/Search.vue'
  import XLSX from 'xlsx'
  import app from '../main'
  import BCTenderStatus from "@/components/BCTenderStatus.vue";

  function calculateData(data) {
		let rowsData = []
		let rows = data
		let created = ''
		let updated = ''
    let proposal_created = ''
    let proposal_updated = ''
		let status = ''
		let createdUpdated = ''
    let proposalCreatedUpdated = ''

		rows.forEach(row => {
			created = moment(String(row.created)).format('DD.MM.YYYY HH:mm')
			updated = moment(String(row.updated)).format('DD.MM.YYYY HH:mm')
			createdUpdated = created

			if (created !== updated) {
				createdUpdated += ' / ' + updated
			}

      proposal_created = moment(String(row.proposal_created)).format('DD.MM.YYYY HH:mm')
      proposal_updated = moment(String(row.proposal_updated)).format('DD.MM.YYYY HH:mm')
      proposalCreatedUpdated = proposal_created

      if (proposal_created !== proposal_updated) {
        proposalCreatedUpdated += ' / ' + proposal_updated
      }

			status = ''
			switch (row.status) {
				case 'DRAFT':
					status = 'Mustand';
					break
				case 'ACTIVE':
					status = 'Aktiivne';
					break
				case 'WAITING':
					status = 'Ootel';
					break
				case 'FINISHED':
					status = 'Lõppenud';
					break
				case 'CHOOSING':
					status = 'Hindamisel';
					break
				case 'ORDERED':
					status = 'Tellitud';
					break
				case 'CANCELED':
					status = 'Tühistatud';
					break
				case 'FAILED':
					status = 'Ebaõnnestunud';
					break
			}

			rowsData.push({
				0: row.id,
				1: row.tender_code,
				2: moment(String(row.start)).format('DD.MM.YYYY HH:mm'),
				3: moment(String(row.finish)).format('DD.MM.YYYY HH:mm'),
				4: row.details_count,
				5: row.proposals_count,
				6: row.winners_count,
				7: row.creator_name,
				8: createdUpdated,
				9: row.approver_name,
        10: proposalCreatedUpdated,
				11: row.group_name,
				12: row.warehouse_name,
				13: status
			})
		})
		return rowsData
	}

	const getData = (route, next) => {
		const search = route.query.search
		const ordering = route.query.ordering || '-start'
		const page = parseInt(route.query.page) || 1

    let stored_filters = JSON.parse(
        localStorage.getItem('etend.filters.' + route.name)
      ) || {}
    let filterStart = route.query.filter_start
        || stored_filters.filter_start
        || moment().subtract(1, 'month').startOf('month').toISOString()
    let filterFinish = route.query.filter_finish
        || stored_filters.filter_finish
        || null
    let filterStatus = route.query.filter_status
        || stored_filters.filter_status
        || ''
	  let groups = route.query.filter_groups
        || stored_filters.filter_groups
    let stored_page_size = JSON.parse(localStorage.getItem('etend.page_size'))
        || {}
    let page_size = route.query.page_size
        || stored_page_size[route.name]
        || process.env.DEFAULT_PAGE_SIZE
    let failed_bc_details = route.query.failed_bc_details
        || stored_filters.failed_bc_details
        || ''


    Promise.all([
      api.get('/tenders/', {
				params: {
					page_size: page_size,
					search: search,
					ordering: ordering,
					page: page,
					filter_groups: groups,
					filter_start: filterStart,
					filter_finish: filterFinish,
					filter_status: filterStatus,
          failed_bc_details: failed_bc_details
				}
			})
		])
			.then(([tenders]) => {
				next({
					rows: tenders.data.results,
					rowsData: calculateData(tenders.data.results),
					search: search,
					ordering: ordering,
					pages: tenders.data.pages,
					count: tenders.data.count,
					page: page,
					filter_start: filterStart,
					filter_finish: filterFinish,
					filter_status: filterStatus,
					page_size: page_size,
          failed_bc_details: failed_bc_details
				})
			})
	}

	export default {
		components: {
      BCTenderStatus,
			contentheading: Contentheading,
			datatablebuttons: Datatablebuttons,
			datetime: Datetime,
			datefilters: Datefilters,
			pagination: Pagination,
			search: Search
		},
		data() {
			return {
				rows: [],
				rowsData: [],
				search: null,
				ordering: null,
				pages: null,
				count: null,
				page: 1,
				page_size: null,
				filter_groups: [],
				selected: [],
				supplier: {},
        disabledFilterBtns: false,
				filter_start: null,
				filter_finish: null,
				filter_status: '',
        failed_bc_details: '',
				columns: [
					this.$i18n.t('tenders.id'),
					this.$i18n.t('tenders.start'),
					this.$i18n.t('tenders.finish'),
					this.$i18n.t('tenders.parts-qty'),
					this.$i18n.t('tenders.proposals'),
					this.$i18n.t('tenders.winners'),
					this.$i18n.t('tenders.creator'),
					this.$i18n.t('tenders.created') + ' / ' + this.$i18n.t('tenders.updated'),
					this.$i18n.t('tenders.approver'),
          this.$i18n.t('tenders.proposal-created') + ' / ' + this.$i18n.t('tenders.proposal-updated'),
					this.$i18n.t('tenders.group'),
					this.$i18n.t('tenders.warehouse'),
					this.$i18n.t('tenders.status')
				]
			}
		},
		mounted() {
			this.$parent.menu = 'tenders'
			this.$parent.submenu = ''
			this.$i18n.locale = this.$store.getters.language
			this.$forceUpdate()
			let hasBeenRedirected = localStorage.getItem('etend.firstSelect');
			let supplierStorageId = localStorage.getItem('etend.supplierId')
			if (supplierStorageId != null && supplierStorageId > 0) {
				Promise.all([
					api.get('/suppliers/' + supplierStorageId + '/')
				])
				.then(([supplier]) => {
					if (supplier.data.category_update_ts == null) {
						if(hasBeenRedirected === "false" || hasBeenRedirected === false) {
							this.$router.push({name: 'supplier_detail', params: {sup_id: supplier.data.id}})
							localStorage.setItem('etend.firstSelect', true);
						}
					}
				})
			}
      let stored_filters = JSON.parse(
          localStorage.getItem('etend.filters.' + this.$route.name)
      )
      if (stored_filters) {
        this.$refs.datefilters.selected = stored_filters.datefilters_selection
        this.filter_groups = stored_filters.filter_groups
      }
		},
		methods: {
      export_selected_rows() {
        let copyJson = []
        return Promise.all([
          api.get('/tenders/', {
            params: {
              ids: this.selected.join(','),
              page_size: 0
            }
          }).then(resp => {
            let rowsData = calculateData(resp.data)
            rowsData.forEach(row => {
              let rowJson = {}
              let i = 1
              this.columns.forEach(col => {
                rowJson[col] = row[i]
                i += 1
              })
              copyJson.push(rowJson)
            })
            let dataWS = XLSX.utils.json_to_sheet(copyJson)
            let wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, dataWS, 'data')
            XLSX.writeFile(wb, 'export.xlsx')
          })
        ])
      },
		  export_all_rows() {
		    let copyJson = []
        return Promise.all([
          api.get('/tenders/', {
            params: {
              page_size: 0,
              search: this.search,
              ordering: this.ordering,
              filter_groups: this.filter_groups,
              filter_start: this.filter_start,
              filter_finish: this.filter_finish,
              filter_status: this.filter_status,
              failed_bc_details: this.failed_bc_details
            }
          }).then(resp => {
            let rowsData = calculateData(resp.data)
            rowsData.forEach(row => {
              let rowJson = {}
              let i = 1
              this.columns.forEach(col => {
                rowJson[col] = row[i]
                i += 1
              })
              copyJson.push(rowJson)
            })
            let dataWS = XLSX.utils.json_to_sheet(copyJson)
            let wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, dataWS, 'data')
            XLSX.writeFile(wb, 'export.xlsx')
          })
        ])
      },
      clear_filters() {
				this.filter_groups = []
				this.filter_start = null
				this.filter_finish = null
				this.filter_status = ''
        this.failed_bc_details = ''
				this.$refs.datefilters.selected = null
				this.$store.dispatch('clearFilters', this.$route.name)
				this.$router.push({query: {clear: true}}).catch(()=>{})
			},
      filter () {
        let filters = {
          search: this.search,
          ordering: this.ordering,
          page: 1,
          filter_groups: this.filter_groups,
          filter_start: this.filter_start,
          filter_finish: this.filter_finish,
          filter_status: this.filter_status
        }
        if (!this.is_supplier) {
          filters["failed_bc_details"] = this.failed_bc_details
        }

        this.$store.dispatch('setFilters', {
          datefilters_selection: this.$refs.datefilters.selected,
          name: 'tenders',
          ...filters
        })
        this.$router.push({
          query:{
            page_size: this.page_size,
            ...filters
          }
        })
			},
      add_watched(id, index) {
        this.$swal({
          type: 'info',
          title: this.$i18n.t('tenders.are-you-sure'),
          text: this.$i18n.t('tenders.are-you-sure-add-watched'),
          showCancelButton: true
        })
            .then((choice) => {
              if (choice.value) {
                api.patch(`/tenders/${id}/add_log/`, 'WATCHED')
                  .then(resp => {
                    this.$set(this.rows[index], 'watched', true)
                    this.$set(this.rows[index], 'watched_date', resp.data.created)
                    message.success(this.$i18n.t('tenders.tender-watched'))
                  })
              }
            })
      },
      remove_watched(id, index) {
        this.$swal({
          type: 'warning',
          title: this.$i18n.t('tenders.are-you-sure'),
          text: this.$i18n.t('tenders.are-you-sure-remove-watched'),
          showCancelButton: true
        })
            .then((choice) => {
              if (choice.value) {
                api.patch(`/tenders/${id}/remove_log/`, 'WATCHED')
                    .then(() => {
                      this.$set(this.rows[index], 'watched', false)
                      this.$set(this.rows[index], 'watched_date', null)
                      message.success(this.$i18n.t('tenders.tender-unwatched'))
                    })
              }
            })
      },
			remove_tender(id, index) {
				this.$swal({
					type: 'warning',
					title: this.$i18n.t('tenders.are-you-sure'),
					text: this.$i18n.t('tenders.are-you-sure-text-cancel'),
					showCancelButton: true
				})
					.then((choice) => {
						if (choice.value) {
							api.post(`/remove_tender/`, {tender_id: id})
								.then(() => {
									message.success(this.$i18n.t('tenders.deleted'))
									this.$delete(this.rows, index)
								})
								.catch(() => {
									message.error(this.$i18n.t('tenders.forbidden'))
								})
						}
					})
			},
			format_date_time(dt) {
				return moment(String(dt)).format('DD.MM.YYYY HH:mm')
			},
			exportExcel(id) {
				api.get(`/tenders/${id}/export_excel/`, {responseType: 'blob'})
					.then(resp => {
						download(
							resp.data,
							'tender_' + id.toString() + '_' + new Date().toLocaleDateString() + '.xls',
							resp.headers['content-type']
						)
					})
			},
			exportPDF(id) {
				api.get(`/tenders/${id}/export_pdf/`, {responseType: 'blob'})
					.then(resp => {
						download(
							resp.data,
							'tender_' + id.toString() + '_' + new Date().toLocaleDateString() + '.pdf',
							resp.headers['content-type']
						)
					})
			},
			order(o) {
        this.$router.push({
          query: {
            search: this.search,
            ordering: o === this.ordering ? '-' + o : o,
            page: 1,
            page_size: this.page_size,
            filter_groups: this.filter_groups,
            filter_start: this.filter_start,
            filter_finish: this.filter_finish,
            filter_status: this.filter_status,
            failed_bc_details: this.failed_bc_details
          }
        })
			},
			paginate(p) {
				this.$router.push({
					query: {
						page: p.page,
            page_size: p.page_size,
						search: this.search,
						ordering: this.ordering,
						filter_groups: this.filter_groups,
						filter_start: this.filter_start,
						filter_finish: this.filter_finish,
						filter_status: this.filter_status,
            failed_bc_details: this.failed_bc_details
					}
				})
			},
			make_search() {
				this.$router.push({
					query: {
						search: this.search,
						ordering: this.ordering,
						page: 1,
						page_size: this.page_size,
						filter_groups: this.filter_groups,
						filter_start: this.filter_start,
						filter_finish: this.filter_finish,
						filter_status: this.filter_status,
            failed_bc_details: this.failed_bc_details
					}
				})
			}
		},
		computed: {
			is_supplier() {
				return this.$store.getters.user_group === 'Supplier'
			},
			warehouse_groups() {
				return JSON.parse(this.$store.getters.warehouse_groups)
			},
			selectAll: {
				get: function () {
					return this.rows ? this.selected.length === this.rows.length : false
				},
				set: function (value) {
					let selected = []
					if (value) {
						this.rows.forEach(function (p) {
							selected.push(p.id)
						})
					}
					this.selected = selected
				}
			}
		},
		beforeRouteEnter(to, from, next) {
			getData(to, data => {
				next(vm => {
					Object.assign(vm.$data, data)
				})
			})
		},
		beforeRouteUpdate(to, from, next) {
			getData(to, data => {
				Object.assign(this.$data, data)
				next()
			})
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/Tenders.vue